import { render } from "./OrganizedMod.vue?vue&type=template&id=2459c461&scoped=true"
import script from "./OrganizedMod.vue?vue&type=script&lang=js"
export * from "./OrganizedMod.vue?vue&type=script&lang=js"

import "./OrganizedMod.vue?vue&type=style&index=0&id=2459c461&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2459c461"]])

export default __exports__